import { useEffect, useRef } from 'react';

// Used for passed-in callback props to create a static enough
// copy of a callback function that will not trigger effects
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const useCallbackRef = <T = Function>(callback: T) => {
  const ref = useRef(callback);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  return ref;
};
